module.exports = __webpack_public_path__ + "img/adviser.c7206c3b.png";